import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Paper from "components/Paper";
import Text from "components/Text";
import Input from "components/FormComponents/ControlledInput";
import Button from "components/Button";
import clsx from "clsx";
import * as yup from "yup";
import { reportError } from "crashlytics";

import styles from "./index.module.css";

import { readFromStorage } from "../../utils/storage";
import { queryClient } from "common/query";
import { QueryKeys, RomanianMonths } from "common/constants";
import { useReserveConfirm, useResendCode } from "queries/service";

const Step8 = () => {
    const history = useHistory();

    //----------start data---------------//
    const departmentName = readFromStorage(QueryKeys.department);
    const serviceName = readFromStorage(QueryKeys.service);
    const date = readFromStorage(QueryKeys.date);
    const time = readFromStorage(QueryKeys.time);
    const personalData = readFromStorage(QueryKeys.personalData);
    const [counter, setCounter] = React.useState(30);


    const schema = yup.object({
        sms_code: yup.number(),
    }).required();

    const defaultValues = {
        sms_code: "",
    };

    const formMethods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(schema)
    });

    const { handleSubmit, formState } = formMethods;

    const {
        mutateAsync: resendCode,
    } = useResendCode();

    const onResendCode = async () => {
        try {
            const result = await resendCode({
                appointment_id: personalData?.appointment_id,
            });
            if (result?.errors) {
                setCounter(30);
            }
            if (result?.data?.success) {
                setCounter(30);
            }
        } catch (error) {
            reportError("ResendCode: onSubmit: error: ", error);
        }
    }

    const {
        mutateAsync: reserveConfirm,
    } = useReserveConfirm();


    const onSubmit = async (data) => {
        if (!personalData?.appointment_id) return;

        try {
            const result = await reserveConfirm({
                appointment_id: personalData?.appointment_id,
                sms_code: data?.sms_code.toString(),

            });
            if (result?.number) {
                queryClient.setQueryData(QueryKeys.successData, {
                    departmentName: departmentName,
                    serviceName: serviceName,
                    date: date,
                    time: time,
                    programmingNumber: result?.number
                });
                history.push("/programare/confirmation")
            }
        } catch (error) {
            reportError("Step8: onSubmit: error:", error);
        }
    };

    useEffect(() => {
        const timer =
            counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
    }, [counter]);

    //----------end data---------------//

    return (
        <div className={styles.step8Page}>
            <div className={styles.pageHeader}>
                <Text type={"h3"}>Pasul 5 din 5</Text>
                <Text type={"h1"}>
                    {departmentName} / {serviceName}
                </Text>
            </div>
            {date &&
                <Paper className={styles.paper}>
                    <Text type={"h3"}>
                        Data: {new Date(date).getDate()}  {RomanianMonths[new Date(date).toLocaleString('default', { month: 'long' })]} {new Date(date).getFullYear()} Ora: {time}
                    </Text>
                </Paper>
            }
            <Paper className={styles.paper}>
                <Text type={"h1"}>Confirmă numărul de telefon</Text>
                <Text type={"h3"}>
                    Ți-am trimis prin SMS pe numărul {personalData?.client_phone} (<span className={styles.linkText} onClick={history.goBack}>modifică numărul</span>), un
                    cod de confirmare din 5 cifre.
                </Text>
                <FormProvider {...formMethods}>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Input
                            name="sms_code"
                            className="mb-12"
                            type="number"
                            label="Introdu aici codul de confirmare din 5 cifre"
                        />
                        <div
                            className={clsx(
                                styles.actionContainer,
                                styles.alignCenter,
                                styles.flexEnd,
                                styles.fullWidth
                            )}
                        >
                            <Button
                                size="large"
                                label="Continuă ->"
                                type="submit"
                                disabled={!formState.isValid}
                            />
                        </div>
                        <Text type={"h3"}>
                            Nu ai primit încă codul? <span className={clsx(styles.linkText, { [styles.disabled]: counter > 0 })} onClick={onResendCode}>Apasă aici</span> pentru retrimitere.
                        </Text>
                        {counter > 0 &&
                            <Text type={"h3"} style={{ color: "#FF0000" }}>
                                Vă rugăm așteptați cel puțin 30 de secunde pentru a cere retrimiterea codului <span style={{ color: "#2B77B1", fontWeight: "bold" }}>(00:{counter > 9 ? counter : `0${counter}`}s)</span>
                            </Text>
                        }
                    </form>
                </FormProvider>
            </Paper>
            <Paper className={styles.paper}>
                <Text type={"h3"}>
                    Dacă nu primești codul SMS, încearcă cu un alt număr de telefon sau
                    sună la 021.9441 pentru a te programa prin telefon.
                </Text>
            </Paper>
        </div>
    );
};

export default Step8;
